import React, { useContext, useEffect, useState } from "react";
import { IMAGES } from "../../assets";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context";
import { useTranslation } from "react-i18next";
import { deactive_user, logOut } from "../../api";
import { STORAGE_KEY, STRINGS } from "../../constants";
import { FILE_URL } from "../../constants/Constants";
import MyPreference from "./tabs/MyPreference";
import LogoutPopup from "../../components/modal/LogoutPopup";
import EditProfile from "../../components/modal/EditProfile";
import moment from "moment";

const Account = () => {
  const { user, profile, fetchProfile, activeLanguage } =
    useContext(AuthContext);
  const { t } = useTranslation();
  const [activeLink, setActiveLink] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [editPopup, setEditPopup] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    getProfile();

    return () => {
      // EventRegister.removeEventListener(listner)
    };
  }, [editPopup]);

  useEffect(() => {
    getRemainingTime();
  }, []);

  async function getProfile() {
    const result = await fetchProfile();
    if (result) {
      getRemainingTime();
    }
  }

  async function getRemainingTime() {
    let userDataLocal = localStorage.getItem(STORAGE_KEY.USER_DETAILS);
    if (userDataLocal) {
      const userData = JSON.parse(userDataLocal);
      if (userData?.userInfo?.subscriptionExpire) {
        let date = moment(userData?.userInfo?.subscriptionExpire).diff(
          moment(),
          "days"
        );
        setRemainingTime(date);
      } else if (userData?.userInfo?.subscriptionExpire == null) {
        setRemainingTime(t(STRINGS.unlimited));
      }
    }
  }

  async function onUserLogout() {
    const params = {
      _id: user?.userInfo?._id,
    };

    setIsLoading(true);
    await logOut(params);
    localStorage.removeItem("user_details_json");
    setIsLoading(false);

    localStorage.removeItem("user_details_json");
    localStorage.removeItem("isFirstTime");

    if (STORAGE_KEY.IS_FIRST_TIME) {
      localStorage.setItem(STORAGE_KEY.IS_FIRST_TIME, "1");
    }

    setTimeout(() => {
      setIsLoading(false);
      navigate("/login");
    }, 500);
  }

  async function onDeactivate() {
    const params = {
      _id: user?.userInfo?._id,
      activeStatus: "false",
    };

    setIsLoading(true);
    const result = await deactive_user(params);
    setIsLoading(false);

    if (result?.status) {
      navigate("/login");
    }
  }
  let formattedRemainingTime;

  if (remainingTime > 0) {
    const expiresInText = t(STRINGS.expires_in);
    const daysText = t(STRINGS.days);
    const formattedTime =
      activeLanguage === "Marathi"
        ? new Intl.NumberFormat("mr").format(remainingTime)
        : new Intl.NumberFormat("en").format(remainingTime);

    formattedRemainingTime = `(${expiresInText} ${formattedTime} ${daysText})`;
  } else {
    formattedRemainingTime = t(STRINGS.expired);
  }
  return (
    <div>
      <div className="grid lg:grid-cols-5 md:grid-cols-5 sm:grid-cols-1 grid-cols-1 gap-4">
        <div className="p-4 shadow-md col-span-3 rounded-2xl bg-white">
          <div className="shadow-md p-4 rounded-2xl">
            <div className="flex items-center gap-2">
              <div className="w-16 h-16 rounded-full bg-slate-400">
                <img
                  alt="profileImage"
                  className="w-full h-full object-fill rounded-full"
                  src={
                    profile?.userImage === ""
                      ? IMAGES?.placeholder
                      : `${FILE_URL}${profile?.userImage}`
                  }
                />
              </div>
              <div>
                <h2 className="text-lg font-medium"> {profile?.fullName}</h2>
                <p className="text-sm font-base text-[#8A8A8A]">
                  {profile?.emailId}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2 justify-between mt-4">
              <button
                onClick={() => setEditPopup(true)}
                className="px-4 py-2 rounded-2xl border w-full border-[#0000000F] text-[#8A8A8A]"
              >
                {t(STRINGS.edit_profile)}
              </button>
              <button
                onClick={() => setIsModal(true)}
                className="px-4 py-2 rounded-2xl border w-full border-[#FE6B01] text-[#FE6B01]"
              >
                {isLoading ? <p>Loading...</p> : <p>{t(STRINGS.log_out)}</p>}
              </button>
            </div>
          </div>
          <div className="mt-4">
            <div className="text-[#545454]">
              <div className="flex items-center justify-between">
                <p>{t(STRINGS?.subscription)}</p>
                <p>{formattedRemainingTime} </p>
              </div>
              <button
                onClick={() => setActiveLink(t(STRINGS?.my_preferances))}
                className={` flex items-center justify-between w-full py-1`}
              >
                <p className="text-start">{t(STRINGS.my_preferances)}</p>
                <img
                  alt="nextlogo"
                  className="h-4 w-auto"
                  src={IMAGES?.nextLogo}
                />
              </button>
            </div>
          </div>
        </div>
        {activeLink && (
          <div className="p-4 shadow-md rounded-2xl bg-white col-span-2">
            {activeLink === t(STRINGS.my_preferances) && <MyPreference />}
          </div>
        )}
      </div>
      {/* logout popup  */}
      <LogoutPopup
        title={t(STRINGS.do_you_want_to_logout)}
        cancel={t(STRINGS.cancel)}
        logout={t(STRINGS.log_out)}
        open={isModal}
        isModal={isModal}
        setIsModal={setIsModal}
        onCancel={() => setIsModal(false)}
        onClick={() => {
          setIsModal(false);
          onUserLogout();
        }}
      />

      {/* Deactivate account  */}
      <LogoutPopup
        title={t(STRINGS?.delete_account_description)}
        cancel={t(STRINGS.cancel)}
        deactivate={t(STRINGS.delete_account)}
        isModal={isSwitchOn}
        setIsModal={setIsSwitchOn}
        onCancel={() => {
          setIsSwitchOn(false);
        }}
        onClick={() => {
          setIsSwitchOn(false);
          onDeactivate();
        }}
      />
      <EditProfile editPopup={editPopup} setEditPopup={setEditPopup} />
    </div>
  );
};

export default Account;
